<template>
<div>
  <ct-popover
      trigger="hover"
      placement="bottom">
      <div slot="popper">{{ $t('user.AvatarPopper') }}</div>
      <div class="avatar-action" @click="showModal" slot="reference">
    <ct-icon name="pencil"></ct-icon>
  </div>
   </ct-popover>

  <ct-modal :title="$t('user.EditAvatarTitle')"
    v-if="visible"
    :class="{'modal-mobile': isMobile}"
    width="700px"
    @closed="closedModal">
    <div slot="body" class="upload-modal">
      <div class="cropper-wrapper">
          <vue-cropper
            ref="cropper"
            class="comet-vue-cropper"
            autoCrop
            :fixedBox="true"
            :autoCropWidth="150"
            :autoCropHeight="150"
            :img="avatarOption.imgSrc"
            :outputSize="avatarOption.size"
            :outputType="avatarOption.outputType"
            :info="true"
            @realTime="realTime">
          </vue-cropper>
          <div class="cropper-btn">
            <span @click="rotate('right')">
              <ct-icon name="rotate"></ct-icon>
            </span>
            <span @click="scale(1)">
              <ct-icon name="fangda"></ct-icon>
            </span>
            <span @click="scale(-1)">
              <ct-icon name="suoxiao"></ct-icon>
            </span>
          </div>
        </div>
        <div class="cropper-preview">
          <div :style="preview.div">
            <img :src="avatarOption.imgSrc" :style="preview.img">
          </div>
        </div>
    </div>
    <div slot="footer" class="footer">
      <div class="choose-file">
        <ct-button
          type="primary"
          >
          {{ $t('common.ChooseFile')}}
            <input type="file" title=""
            name="file"
            @change="handleChangeFile"
            class="file-input">
          </ct-button>
      </div>
      <ct-button type="text_secondary_light" @click.prevent="closedModal">{{ this.$t('common.Cancel') }}</ct-button>
      <ct-button
      type="primary"
      :disabled="avatarOption.imgSrc===''"
      :isLoading="loadingUploadBtn"
      @click.prevent="uploadAvatar"
      >{{ this.$t('common.Submit') }}</ct-button>
    </div>
  </ct-modal>
</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { VueCropper } from 'vue-cropper'
import CtPopover from '@ca/components/CtPopover'

export default {
  name: 'EditAvatar',
  components: {
    'ct-popover': CtPopover,
    'vue-cropper': VueCropper
  },
  data () {
    return {
      visible: false,
      pending: false,
      loadingUploadBtn: false,
      uploadModalVisible: false,
      preview: {},
      avatarOption: {
        imgSrc: '',
        size: 0.8,
        outputType: 'png'
      },
      isMobile: window.innerWidth <= 768
    }
  },
  watch: {
    profile (value) {
      this.signature = value.signature || ''
    }
  },
  computed: {
    ...mapGetters(['profile']),
    count () {
      const signature = this.signature.toString()
      return signature.length
    },
    loading () {
      return this.pending
    },
    previewStyle () {
      return {
        'width': this.preview.w + 'px',
        'height': this.preview.h + 'px',
        'overflow': 'hidden'
      }
    }
  },
  methods: {
    ...mapActions(['updateUserInfo']),
    showModal () {
      this.visible = true
    },
    closedModal () {
      this.visible = false
      this.avatarOption.imgSrc = ''
    },
    setProfile () {
      this.uploadModalVisible = true
    },
    handleChangeFile (event) {
      this.showModal()
      if (event.target.files.length > 0) {
        this.handleSelectFile(event.target.files[0])
      }
    },
    checkFileType (file) {
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        this.$toast({
          message: this.$t('common.FileSupport'),
          type: 'warning',
          duration: 2000
        })
        return false
      }
      return true
    },
    checkFileSize (file) {
      // max size is 3MB
      if (file.size > 3 * 1024 * 1024) {
        this.$toast({
          message: this.$t('common.ExceedMaxSize3M'),
          type: 'warning',
          duration: 2000
        })
        return false
      }
      return true
    },
    handleSelectFile (file) {
      let isOk = this.checkFileType(file) && this.checkFileSize(file)
      if (!isOk) {
        return false
      }
      let reader = new window.FileReader()
      reader.onload = (e) => {
        this.avatarOption.imgSrc = e.target.result
      }
      reader.readAsDataURL(file)
      return false
    },
    realTime (data) {
      this.preview = data
    },
    rotate (direction) {
      if (direction === 'left') {
        this.$refs.cropper.rotateLeft()
      } else {
        this.$refs.cropper.rotateRight()
      }
    },
    scale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    uploadAvatar () {
      this.$refs.cropper.getCropBlob(blob => {
        let form = new window.FormData()
        let file = new window.File([blob], 'avatar.' + this.avatarOption.outputType)
        form.append('file', file)
        this.loadingUploadBtn = true
        let url = '/user/uploadAvatar'
        this.$http({
          method: 'post',
          url,
          data: form,
          headers: { 'content-type': 'multipart/form-data' }
        }).then(res => {
          this.loadingUploadBtn = false
          this.closedModal()
          this.$toast({ message: this.$t('common.SubmitSuccess'),
            type: 'success',
            duration: 2000
          })
          this.uploadModalVisible = false
          this.avatarOption.imgSrc = ''
          this.$store.dispatch('getProfile')
        }, () => {
          this.loadingUploadBtn = false
        })
      })
    }
  },
  mounted () {
    this.signature = this.profile.signature || ''
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/_varaible.scss';

$textColor: #A3B1BF;
.is-circle{
  font-size: inherit;
}
.avatar{
  &-action {
    position: relative;
    width: 100%;
    bottom: 0;
    height:36px;
    line-height:36px;
    background:rgba(0, 0, 0, 0.46);
    color: #fff;
    text-align: center;
    margin-top: -36px;
    cursor: pointer;
  }
  .file-input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    opacity: 0;
    cursor: pointer;
  }
}
.cropper{
  &-wrapper{
    display: inline-block;
    position: relative;
    border-radius:2px;
    border:1px solid rgba(219,224,230,1);
    margin-right: 74px;
    .comet-vue-cropper{
      width: 400px;
      height: 300px;
    }
  }
  &-btn{
    position: absolute;
    top: 0;
    right: -40px;
    width:40px;
    font-size: 24px;
    cursor: pointer;
    >span{
      display: inline-block;
      width:100%;
      line-height: 40px;
      height:40px;
      text-align: center;
      border:1px solid rgba(219,224,230,1);
      border-left: 0;
    }
    >span + span{
      border-top: none;
    }
  }
  &-preview {
    width:158px;
    height:158px;
    display: inline-block;
    border:4px solid rgba(55,202,215,1);
    border-radius: 50%;
    overflow: hidden;
    vertical-align: top;
    margin-top: 74px;
  }
  &-img {
    width: 400px;
    height: 300px;
  }
}
.modal-mobile /deep/ {
    .ct-modal--box {
        width: 96%!important;
        padding: 60px 10px;
        height: 90%;
        overflow: scroll;
        text-align: center;
    }
    .cropper-wrapper {
        .comet-vue-cropper {
            width: 340px;
            height: 300px;
        }
        .cropper-btn {
            top: 300px;
            left: 0;
            width: 100%;
            span {
                width: 40px;
            }
        }
    }
    .cropper-preview {
    }
    .footer {
        .choose-file {
            width: 100%;
            text-align: center;
            float: left;
            position:relative;
            margin-bottom: 20px;
        }
    }
}

</style>
